import { useMemo, useState } from "react"
import { ECourierVehicleType } from "../../Enum/ECourierVehicleType"

export const COURIER_FINANCIAL_TERM_VERSION = "2025-02"

export interface CreateCourierDto {
  name: string
  phone: string
  email: string
  password: string
  companyEntityId?: number
  eCourierVehicleType: number
  hasAcceptedFinancialResponsibilityTerm: boolean
  financialResponsibilityTermVersion: string
}

export const useCreateCourier = () => {
  const [name, setName] = useState("")

  const [phone, setPhone] = useState("")

  const [email, setEmail] = useState("")

  const [password, setPassword] = useState("")

  const [vehicleType, setVehicleType] = useState<ECourierVehicleType>(ECourierVehicleType.MotorCycle)

  const [companyEntityId, setCompanyEntityId] = useState<number | undefined>(undefined)

  const [acceptedFinancialTerm, setAcceptedFinancialTerm] = useState(false)

  const [loading, setLoading] = useState(false)

  const isValid = useMemo(
    () =>
      name.trim().length >= 3 &&
      phone.trim().length >= 8 &&
      email.includes("@") &&
      password.length >= 6 &&
      acceptedFinancialTerm,
    [name, phone, email, password, acceptedFinancialTerm],
  )

  const handleVehicleTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) =>
    setVehicleType(Number(e.target.value) as ECourierVehicleType)

  const handleSubmitForm = (): CreateCourierDto => ({
    name,
    phone,
    email,
    password,
    companyEntityId,
    eCourierVehicleType: vehicleType,
    hasAcceptedFinancialResponsibilityTerm: acceptedFinancialTerm,
    financialResponsibilityTermVersion: COURIER_FINANCIAL_TERM_VERSION,
  })

  const resetForm = () => {
    setName("")
    setPhone("")
    setEmail("")
    setPassword("")
    setVehicleType(ECourierVehicleType.MotorCycle)
    setCompanyEntityId(undefined)
    setAcceptedFinancialTerm(false)
  }

  return {
    name,
    phone,
    email,
    password,
    vehicleType,
    companyEntityId,
    acceptedFinancialTerm,
    loading,
    isValid,
    setName,
    setPhone,
    setEmail,
    setPassword,
    setVehicleType,
    setCompanyEntityId,
    setAcceptedFinancialTerm,
    setLoading,
    handleVehicleTypeChange,
    handleSubmitForm,
    resetForm,
  }
}
